module.exports = __webpack_public_path__ + "static/media/newwearteklogo.3abf7a46.png";